import { render, staticRenderFns } from "./VaultFilesList.vue?vue&type=template&id=06cf2f87&scoped=true&"
import script from "./VaultFilesList.vue?vue&type=script&lang=ts&"
export * from "./VaultFilesList.vue?vue&type=script&lang=ts&"
import style0 from "./VaultFilesList.vue?vue&type=style&index=0&id=06cf2f87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cf2f87",
  null
  
)

export default component.exports